module.exports = __webpack_public_path__ + "static/daniel-ilinca-f950d68772aacb707ad86cfac8f42d01.jpg";